import { render } from "./PNoCoins.vue?vue&type=template&id=6e66267f"
import script from "./PNoCoins.vue?vue&type=script&lang=js"
export * from "./PNoCoins.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__